import i18n from "@/plugins/i18n";
import { ComplainType } from "./complainType";

export interface IComplainType {
	text: string;
	value: ComplainType;
}

export function getComplainTypes(): IComplainType[] {
	return [
		{
			text: i18n.t("dtoLabels.complainType.outOfTolerance") as string,
			value: ComplainType.OutOfTolerance,
		},
		{
			text: i18n.t("dtoLabels.complainType.wrongBending") as string,
			value: ComplainType.WrongBending,
		},
		{
			text: i18n.t("dtoLabels.complainType.cutQualityLow") as string,
			value: ComplainType.CutqualityLow,
		},
		{
			text: i18n.t("dtoLabels.complainType.scratches") as string,
			value: ComplainType.Scratches,
		},
		{
			text: i18n.t("dtoLabels.complainType.missingCuts") as string,
			value: ComplainType.MissingCuts,
		},
		{
			text: i18n.t("dtoLabels.complainType.wrongGrainDirection") as string,
			value: ComplainType.WrongGrainDirection,
		},
		{
			text: i18n.t("dtoLabels.complainType.transportDamage") as string,
			value: ComplainType.TransportDamage,
		},
		{
			text: i18n.t("dtoLabels.complainType.missing") as string,
			value: ComplainType.Missing,
		},
		{
			text: i18n.t("dtoLabels.complainType.powderCoating") as string,
			value: ComplainType.PowderCoating,
		},
		{
			text: i18n.t("dtoLabels.complainType.weldline") as string,
			value: ComplainType.Weldline,
		},
		{
			text: i18n.t("dtoLabels.complainType.feature") as string,
			value: ComplainType.Feature,
		},
		{
			text: i18n.t("dtoLabels.complainType.other") as string,
			value: ComplainType.Other,
		},
		{
			text: i18n.t("dtoLabels.complainType.zincCoating") as string,
			value: ComplainType.ZincCoating,
		},
		{
			text: i18n.t("dtoLabels.complainType.wrongOrMissingPressJoin") as string,
			value: ComplainType.WrongOrMissingPressJoin,
		},
	];
}
